(function () {
  const store = window.ScrubLabTeams.store;

const recognisedColours = [
  // CORE
  'Black',
  'Navy',
  'Ceil',
  'Maroon',
  'Hunter Green',
  'Aubergine',
  'Grey',

  // SOFT
  'Powder Blue',
  'Soft Beige',
  'Lavender Haze',
  'Powder Pink',

  // BOLD
  'Peach',
  'Orange',
  'Yellow',
  'Brown',
  'Royal Blue',
  'Picasso Pink',
  'Mauve',
  'Khaki',

  // CLEARANCE
  'Teal',
  'White',
  'Fuchsia',
  'Candy Pink'
];

  const colourAliases = {
    'Ceil': ['Ceil', 'Ceil Blue'],
    'Khaki': ['Khaki', 'Combat Khaki'],
    'Brown': ['Brown', 'Pecan Brown'],
    'Peach': ['Peach', 'Peach Quartz']
  };

  const colourGroups = {
    'Core': [
      'Black',
      'Navy',
      'Ceil',
      'Maroon',
      'Hunter Green',
      'Aubergine',
      'Grey'
    ],
    'Soft': [
      'Powder Blue',
      'Soft Beige',
      'Lavender Haze',
      'Powder Pink'
    ],
    'Bold': [
      'Peach',
      'Orange',
      'Yellow',
      'Brown',
      'Royal Blue',
      'Picasso Pink',
      'Mauve',
      'Khaki'
    ],
    'Clearance': [
      'Teal',
      'White',
      'Fuchsia',
      'Candy Pink'
    ]
  };

  store.initialiseCatalogueFilters = function () {
    const root = store.root;
    const cards = [...root.querySelectorAll('[data-product-card]')];
    const colourSelect = root.querySelector('[data-filter="colour"]');

    if (!colourSelect) return;



    const normalise = (value) =>
      String(value || '').trim().toLowerCase();

    const availableColours = new Map();

    cards.forEach((card) => {
      // Accessories are not part of the scrub bundle catalogue.
      if (!card.dataset.category?.trim()) {
        card.remove();
        return;
      }

      const tags = (card.dataset.tags || '')
        .split('|')
        .map(normalise);

      recognisedColours.forEach((colour) => {
        const aliases = colourAliases[colour] || [colour];

        const hasColour = aliases.some((alias) =>
          tags.includes(normalise(alias))
        );

        if (hasColour) {
          availableColours.set(normalise(colour), colour);
        }
      });
    });

    const selectedColour = colourSelect.value;

    colourSelect.innerHTML = '';

    colourSelect.add(new Option('All colours', ''));

    Object.entries(colourGroups).forEach(([groupName, colours]) => {
      const availableInGroup = colours.filter((colour) =>
        availableColours.has(normalise(colour))
      );

      if (!availableInGroup.length) return;

      const group = document.createElement('optgroup');
      group.label = groupName;

      availableInGroup.forEach((colour) => {
        group.appendChild(
          new Option(colour, normalise(colour))
        );
      });

      colourSelect.appendChild(group);
    });

    if ([...colourSelect.options].some(
      (option) => option.value === selectedColour
    )) {
      colourSelect.value = selectedColour;
    }

    store.applyProductFilters();
  };
  
  store.applyProductFilters = function () {
    const root = store.root;

    const category = root.querySelector('[data-filter="category"]')?.value || '';
    const colour = root.querySelector('[data-filter="colour"]')?.value || '';
    const fit = root.querySelector('[data-filter="gender"]')?.value || '';

    const cards = root.querySelectorAll('[data-product-card]');

    const normalise = (value) =>
      String(value || '').trim().toLowerCase();



    const fitTags = {
      womens: 'Women',
      mens: 'Men',
      unisex: 'Unisex'
    };

    let visibleCount = 0;

    cards.forEach((card) => {
      const categories = normalise(card.dataset.category).split(/\s+/);

      const tags = (card.dataset.tags || '')
        .split('|')
        .map(normalise)
        .filter(Boolean);

      const matchesCategory =
        !category || categories.includes(normalise(category));

const selectedColour = recognisedColours.find(
  (name) => normalise(name) === normalise(colour)
);

const acceptedColours = selectedColour
  ? colourAliases[selectedColour] || [selectedColour]
  : [colour];

const matchesColour =
  !colour ||
  acceptedColours.some((name) => tags.includes(normalise(name)));

      const matchesFit =
        !fit || tags.includes(normalise(fitTags[fit] || fit));

      const isVisible =
        matchesCategory && matchesColour && matchesFit;

      card.hidden = !isVisible;
      card.style.display = isVisible ? '' : 'none';

      if (isVisible) visibleCount++;
    });

    // Show a message when no products match.
    const grid = root.querySelector('[data-product-grid]');

    if (!grid) return;

    let emptyMessage = root.querySelector('[data-filter-empty]');

    if (!emptyMessage) {
      emptyMessage = document.createElement('p');
      emptyMessage.setAttribute('data-filter-empty', '');
      emptyMessage.textContent =
        'No products match your filters. Try another combination.';

      grid.insertAdjacentElement('afterend', emptyMessage);
    }

    emptyMessage.hidden = visibleCount > 0;
    emptyMessage.style.display = visibleCount > 0 ? 'none' : 'block';
  };

  store.bindEvents = function () {

    // Product filtering
    store.root.addEventListener('change', function (event) {
      if (event.target.matches('[data-filter]')) {
        store.applyProductFilters();
      }
    });

    // Existing bundle functionality
    store.root.addEventListener('click', function (event) {
      // OPEN MOBILE BUNDLE PANEL
      const openMobileBundle = event.target.closest(
        '[data-open-mobile-bundle]'
      );

      if (openMobileBundle) {
        const panel = store.root.querySelector('.team-builder__team');
        const overlay = store.root.querySelector(
          '.team-builder__mobile-overlay'
        );

        if (panel && overlay) {
          panel.classList.add('is-mobile-open');
          overlay.hidden = false;

          openMobileBundle.setAttribute('aria-expanded', 'true');
          document.documentElement.style.overflow = 'hidden';
        }

        return;
      }

      // CLOSE MOBILE BUNDLE PANEL
      const closeMobileBundle = event.target.closest(
        '[data-close-mobile-bundle]'
      );

      if (closeMobileBundle) {
        const panel = store.root.querySelector('.team-builder__team');
        const overlay = store.root.querySelector(
          '.team-builder__mobile-overlay'
        );

        if (panel && overlay) {
          panel.classList.remove('is-mobile-open');
          overlay.hidden = true;

          const openButton = store.root.querySelector(
            '[data-open-mobile-bundle]'
          );

          openButton?.setAttribute('aria-expanded', 'false');

          document.documentElement.style.overflow = '';
        }

        return;
      }
      const openProduct = event.target.closest('[data-open-product]');

      if (openProduct) {
        store.openDrawer(openProduct.dataset.productHandle);
        return;
      }

      const closeDrawer = event.target.closest('[data-close-drawer]');

      if (closeDrawer) {
        store.closeDrawer();
        return;
      }

const productOption = event.target.closest('[data-product-option]');

if (productOption) {
  if (productOption.disabled) return;

  const optionIndex = Number(productOption.dataset.optionIndex);
  const selectedValue = productOption.dataset.optionValue;

  const drawer = store.state.drawer;
  const product = drawer.product;

  if (!product) return;

  // Update the selected option without rebuilding the drawer.
  const nextOptions = [...drawer.selectedOptions];
  nextOptions[optionIndex] = selectedValue;

  const selectedVariant = store.getVariantByOptions(
    product,
    nextOptions
  );

  // Do not allow unavailable combinations.
  if (!selectedVariant || !selectedVariant.available) return;

  drawer.selectedOptions = nextOptions;

  // Update the option buttons while leaving embroidery untouched.
  const optionsMarkup = store.getProductOptionsMarkup(
    product,
    nextOptions
  );

  const existingGroups = [
    ...store.els.drawerContent.querySelectorAll(
      '.team-builder__option-group'
    )
  ];

  if (existingGroups.length) {
    const template = document.createElement('template');
    template.innerHTML = optionsMarkup;

    const newGroups = [
      ...template.content.querySelectorAll(
        '.team-builder__option-group'
      )
    ];

    existingGroups.forEach((group, index) => {
      if (newGroups[index]) {
        group.replaceWith(newGroups[index]);
      }
    });
  }

  // Update the displayed product price.
  const priceElement = store.els.drawerContent.querySelector(
    '.team-builder__drawer-product p:last-child'
  );

  if (priceElement) {
    priceElement.textContent = store.money(selectedVariant.price);
  }

  // Update the Add to Bundle button.
  const addButton = store.els.drawerContent.querySelector(
    '[data-add-real-product]'
  );

  if (addButton) {
    addButton.disabled = false;
    addButton.textContent = 'Add to Bundle';
  }

  return;
}

      const addProduct = event.target.closest('[data-add-real-product]');

      if (addProduct) {
        const product = store.state.drawer.product;
        const selectedOptions = store.state.drawer.selectedOptions;

        if (!product) return;

        const selectedVariant =
          store.getVariantByOptions(product, selectedOptions);

        if (!selectedVariant || !selectedVariant.available) {
          alert('This variant is not available.');
          return;
        }

        // Capture embroidery selections from the Quick Add customiser.
        const customiser = store.els.drawerContent.querySelector(
          '.scrublab-customiser'
        );

        const embroideryProperties = {};

        if (customiser) {
          const fields = customiser.querySelectorAll(
            '[name^="properties["]'
          );

          fields.forEach((field) => {
            if (field.disabled || !field.name) return;

            if (
              (field.type === 'checkbox' || field.type === 'radio') &&
              !field.checked
            ) {
              return;
            }

            const propertyName = field.name.match(
              /^properties\[(.*)\]$/
            )?.[1];

            if (!propertyName) return;

            const value = String(field.value || '').trim();

            if (!value) return;

            embroideryProperties[propertyName] = value;
          });
        }

        const hasEmbroidery = Object.entries(
          embroideryProperties
        ).some(([key, value]) => {
          return (
            /Chest Type$/i.test(key) &&
            !['none', 'no embroidery'].includes(
              String(value).toLowerCase()
            )
          );
        });

        store.addItem({
          productId: product.id,
          productHandle: product.handle,
          title: product.title,
          image:
            selectedVariant.featured_image?.src ||
            product.featured_image ||
            '',
          variantId: selectedVariant.id,
          variantTitle: selectedVariant.title,
          price: selectedVariant.price,
          options: [...selectedOptions],

          // Preserve this garment's individual embroidery configuration.
          embroidery: hasEmbroidery
            ? {
                properties: embroideryProperties,

                // Convert the customiser's dollar amount into Shopify cents.
                price: Math.round(
                  Number(
                    String(
                      embroideryProperties['Embroidery Total'] || '0'
                    ).replace(/[^0-9.]/g, '')
                  ) * 100
                )
              }
            : null
        });

        return;
      }

      // ADD COMPLETE BUNDLE TO SHOPIFY CART
      const addBundleButton = event.target.closest(
        '[data-add-bundle-to-cart]'
      );

      if (addBundleButton) {
        store.addBundleToCart();
        return;
      }

      const increaseButton =
        event.target.closest('[data-increase-quantity]');

      if (increaseButton) {
        const itemId = increaseButton.dataset.increaseQuantity;

        const item = store.state.items.find(
          (item) => item.id === itemId
        );

        if (item) {
          store.updateItemQuantity(itemId, item.quantity + 1);
        }

        return;
      }

      const decreaseButton =
        event.target.closest('[data-decrease-quantity]');

      if (decreaseButton) {
        const itemId = decreaseButton.dataset.decreaseQuantity;

        const item = store.state.items.find(
          (item) => item.id === itemId
        );

        if (item) {
          store.updateItemQuantity(itemId, item.quantity - 1);
        }

        return;
      }

      const removeButton = event.target.closest('[data-remove-item]');

      if (removeButton) {
        store.removeItem(removeButton.dataset.removeItem);
        return;
      }

    });
  };

})();